import api from "PFCore/api";
import { SkillsFramework, SkillsFrameworkCreateUpdateData } from "PFTypes/skills_framework";

export const createSkillsFramework = (data: SkillsFrameworkCreateUpdateData) =>
  api<SkillsFramework>({
    url: "admin/skills_framework/templates",
    method: "POST",
    data
  });
